import Create from "./Create";
import List from "./List";
import Update from "./Update";

export const Partners = {
  List: List,
  Update: Update,
  Create: Create,
  Permissions: {
    create: "create:Partner",
    read: "read:Partner",
    list: "list:Partner",
    update: "update:Partner",
    delete: "delete:Partner",
  },
};
